"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _matches = _interopRequireDefault(require("validator/lib/matches"));

var _genericInput = _interopRequireDefault(require("./generic-input"));

var _atomImage = require("@xe/atom-image");

var PasswordAppraisal = (0, _component["default"])(function () {
  return import("./password-appraisal");
});

var NudeButton = _styledComponents["default"].button.attrs({
  type: "button"
}).withConfig({
  displayName: "NudeButton",
  componentId: "sc-1rlfdcw-0"
})(["border:none;padding:0;background:transparent;vertical-align:middle;line-height:0;"]);

var PasswordInput = function (_Component) {
  (0, _inheritsLoose2["default"])(PasswordInput, _Component);

  function PasswordInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.passwordValidation = function (value) {
      var satisfiesLengthRequirement = false,
          satisfiesLowercaseRequirement = false,
          satisfiesUppercaseRequirement = false,
          satisfiesNonAlphaRequirement = false,
          satisfiesTrimmedWhitespaceRequirement = false;

      if (value.length >= 8) {
        satisfiesLengthRequirement = true;
      }

      if ((0, _matches["default"])(value, /[a-z]/)) {
        satisfiesLowercaseRequirement = true;
      }

      if ((0, _matches["default"])(value, /[A-Z]/)) {
        satisfiesUppercaseRequirement = true;
      }

      if ((0, _matches["default"])(value, /[^a-zA-Z]/)) {
        satisfiesNonAlphaRequirement = true;
      }

      if (value === value.trim()) {
        satisfiesTrimmedWhitespaceRequirement = true;
      }

      var valid = satisfiesLengthRequirement && satisfiesLowercaseRequirement && satisfiesUppercaseRequirement && satisfiesNonAlphaRequirement && satisfiesTrimmedWhitespaceRequirement;
      var checklistConfig = [{
        message: "At least 8 characters long",
        isSatisfied: satisfiesLengthRequirement
      }, {
        message: "At least 1 lowercase letter",
        isSatisfied: satisfiesLowercaseRequirement
      }, {
        message: "At least 1 capital letter",
        isSatisfied: satisfiesUppercaseRequirement
      }, {
        message: "At least 1 non-alphabetical character",
        isSatisfied: satisfiesNonAlphaRequirement
      }, {
        message: "No leading or trailing whitespace",
        isSatisfied: satisfiesTrimmedWhitespaceRequirement
      }];

      var errorMessage = _react["default"].createElement(PasswordAppraisal, {
        ref: _this.appraisal,
        passwordToRate: value,
        checklistConfig: checklistConfig,
        correspondingPasswordId: _this.props.inputId
      });

      return {
        valid: valid,
        errorMessage: errorMessage
      };
    };

    _this.handleEyeClick = function () {
      _this.setState({
        isPasswordVisible: !_this.state.isPasswordVisible
      });
    };

    _this.handleFocus = function () {
      if (_this.appraisal.current) {
        _this.appraisal.current.forceExpand();
      }
    };

    _this.handleBlur = function () {
      if (_this.appraisal.current) {
        _this.appraisal.current.sendAccessibleErrorAlert();
      }
    };

    _this.state = {
      isPasswordVisible: false
    };
    _this.appraisal = _react["default"].createRef();
    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.render = function render() {
    var Eye = this.state.isPasswordVisible ? _atomImage.CrossedOutEyeIcon : _atomImage.EyeIcon;
    var eyeText = this.state.isPasswordVisible ? "Hide password" : "Show password";
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_genericInput["default"], (0, _extends2["default"])({}, this.props, {
      debounceTime: 0,
      inputType: this.state.isPasswordVisible ? "text" : "password",
      validator: this.props.isSignUpMode ? this.passwordValidation : null,
      decorationOverride: _react["default"].createElement(NudeButton, {
        onClick: this.handleEyeClick
      }, _react["default"].createElement(Eye, {
        color: null,
        "aria-label": eyeText
      })),
      initialErrorMessage: this.props.isSignUpMode ? this.passwordValidation("").errorMessage : null,
      persistCustomErrorMessage: this.props.isSignUpMode,
      overrideAriaDescribedBy: this.props.isSignUpMode ? "".concat(this.props.inputId, "-accessiblePasswordRequirements") : null,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    })));
  };

  return PasswordInput;
}(_react.Component);

PasswordInput.defaultProps = {
  labelText: "Password",
  inputId: "password",
  inputName: "password",
  isSignUpMode: false
};
var _default = PasswordInput;
exports["default"] = _default;